import { render, staticRenderFns } from "./my-table-config.vue?vue&type=template&id=6ebce68b"
import script from "./my-table-config.vue?vue&type=script&lang=js"
export * from "./my-table-config.vue?vue&type=script&lang=js"
import style0 from "./my-table-config.vue?vue&type=style&index=0&id=6ebce68b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports